module.exports = __webpack_public_path__ + "img/back.460135c2.svg";